import React from 'react'
import { Box, MenuItem, Typography, SelectProps } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { Option } from '~/utils/selectOptions'
import { TextInput, TextInputProps } from '~/components'
import clsx from 'clsx'
import { mutualTheme } from '~/utils/theme'
import { InputSubtitle } from '../InputSubtitle'

export type SelectInputProps = SelectProps & TextInputProps & {
  options: Option[],
  error?: any
}

const useStyles = makeStyles({
  label: {
    marginBottom: mutualTheme.spacing(0.5),
    color: mutualTheme.palette.textGray1.main
  },
  container: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  subTitle: {
    marginTop: mutualTheme.spacing(1)
  }
})

export const SelectInput = React.forwardRef<HTMLDivElement, SelectInputProps>((props, ref) => {
  const { options, outsideLabel, containerClassName, subtitle, placeholder, value, ...otherProps } = props
  const classes = useStyles()

  return (
    <Box className={clsx([classes.container, containerClassName])}>
      {outsideLabel && <Typography variant='body2' className={classes.label}>{props.label}</Typography>}
      <TextInput
        {...otherProps}
        select
        ref={ref}
        fullWidth
        value={value}
        variant='outlined'
        SelectProps={{
          displayEmpty: true
        }}
        placeholder={placeholder}
        label={!outsideLabel && props.label}
      >
        <MenuItem value='' disabled>
          {placeholder}
        </MenuItem>
        {options.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextInput>
      {subtitle && <InputSubtitle className={classes.subTitle} text={subtitle} />}
    </Box>
  )
})
